import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'

import { OverlayTrigger, Tooltip } from 'react-bootstrap'


const NavItem = withRouter((props) => {

    const { to, children, location } = props;

    return (
        <li className={location.pathname === to ? 'nav-active' : null}>
            <Link to={{ pathname: to, search: location.search }}>{children}</Link >
        </li>
    )
});

class SideBar extends Component {

    render() {
        return (
            <div className="sidebar-left" >
                <div className="sidebar-left-info">
                    <div className=" search-field"></div>

                    <ul className="nav nav-pills nav-stacked side-navigation">
                        <li>
                            <h3 className="navigation-title">Navigation</h3>
                        </li>
                        <NavItem to="/report">
                            <OverlayTrigger placement="right" overlay={<Tooltip id="edit">Report Card</Tooltip>}>
                                <i className="fa fa-bar-chart-o"></i>
                            </OverlayTrigger>
                        </NavItem>
                        <NavItem to="/summary" activeClassName="nav-active">
                            <OverlayTrigger placement="right" overlay={<Tooltip id="edit">Project Summary</Tooltip>}>
                                <i className="fa fa-align-left"></i>
                            </OverlayTrigger>
                        </NavItem>
                        { this.props.enableModernization &&
                            <NavItem to="/modernize" activeClassName="nav-active">
                                <OverlayTrigger placement="right" overlay={<Tooltip id="edit">Modernization Path</Tooltip>}>
                                    <i className="fa fa-cloud"></i>
                                </OverlayTrigger>
                            </NavItem>
                        }
                        { this.props.enableEstimate &&
                            <NavItem to="/estimate" activeClassName="nav-active">
                                <OverlayTrigger placement="right" overlay={<Tooltip id="edit">Upgrade Estimate</Tooltip>}>
                                    <i className="fa fa-calculator"></i>
                                </OverlayTrigger>
                            </NavItem>
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default SideBar;


